import { BASE_API_URL } from "utils/constants";
import { get, post } from '../../utils/api';
import { CommonDataResponse } from "./common_services";

// ======================= TIÊU CHÍ =================================================================
export type CommonCriteria = {
  title: string,
  value: string,
  key: string,
  parentTitle: string,
  children: CommonCriteria[];
}

export type CriterialListModel = CommonCriteria & Partial<{
  children: CommonCriteria[];
}>

export type CriterialResponse = {
  data: CriterialListModel[]
  message: string;
  isSuccess: boolean;
}



// ============ Khai báo phương thức =====================
export interface ICriterialServices {

  // get dropdown criteria danh sách tiêu chí


  // Tạo chi tiết tiêu chí


  // danh sách tiêu chí
  getDataCriterial(): Promise<CommonDataResponse>
  //  tạo mới tiêu chí (mới)
  getDataCriterial2(): Promise<CriterialResponse>


  //  data từng tiêu chí
  getDataDetailCriterial(key: string): Promise<CommonDataResponse>
}
// Hàm khởi tạo các phương thức của NKMH service
export function createCriterialServices(): ICriterialServices {
  return {
    // danh sách tiêu chí
    getDataCriterial: async () => {
      return (
        await get(
          BASE_API_URL,
          `Criterial/criterial`))
        .data;
    },
    //  data từng tiêu chí
    getDataDetailCriterial: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Criterial/detail-criterial/` + key))
        .data;
    },
    //  data từng tiêu chí (mới)
    getDataCriterial2: async () => {
      return (
        await get(
          BASE_API_URL,
          `Criteria/gets-criteria`))
        .data;
    },
  };
}
